module.exports = __webpack_public_path__ + "img/temoignage-3-rounded.76a5737c.jpg";